import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'under-construction-page',
	template: '<h1>Under Construction</h1>',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	host: {
		class: 'block w-100 h-100',
	},
})
export class UnderConstructionPage {}
